// [NEED] 객체로 바꾸기...
export const estimateDefaultInfo = [
    {
        label: "발행일",
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        disabled: true,
        rules: [(v) => !!v || "필수 입력"],
    },
    {
        label: "사내 견적번호",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "기업별 입찰번호",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
];
export const estimateDefaultInfo2 = [
    {
        label: "납기",
        type: "dateSingle",
        menu: "",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        disabled: true,
        rules: [(v) => !!v || "필수 입력"],
    },
    {
        label: "견적명",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "견적 기간",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "특이사항",
        col: "12",
        sm: "4",
        lg: "12",
        value: "",
        disabled: true,
    },
];
export const _searchEstimateHeaders = [
    {
        text: "사내 견적번호",
        align: "center",
        value: "inhouseBidNumber",
    },
    {
        text: "기업별 입찰번호",
        align: "center",
        value: "companyBidNumber",
    },
    { text: "작성자", align: "center", value: "createrName" },
    { text: "업체명", align: "center", value: "companyName" },
    { text: "발행일", align: "center", value: "createdTime" },
    { text: "총액", align: "center", value: "totalPrice" },
];
// 검색 필터 조건
export const _searchCardInputs = [
    {
        key: "inhouseBidNumber",
        label: "사내 견적번호",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        key: "companyBidNumber",
        label: "기업별 입찰번호",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        key: "companyName",
        label: "업체명",
        col: "12",
        sm: "4",
        lg: "4",
        value: "",
    },
    {
        key: "issueDate",
        label: "발행일",
        type: "dateRange",
        range: true,
        value: [],
        col: "12",
        sm: "4",
        lg: "8",
    },
];
export const _estimateSearchCompanyInfoInputs = [
    {
        label: "업체명",
        column_name: "company_name",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "담당자",
        column_name: "company_manager",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [(v) => !!v || "필수 입력"],
        disabled: true,
    },
    {
        label: "담당자 E-mail",
        column_name: "company_manager_email",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [
            (v) => !!v || "필수 입력",
            (v) => (typeof v === "string" && /.+@.+\..+/.test(v)) || "이메일 형식 확인",
        ],
        disabled: true,
    },
    {
        label: "담당자 연락처",
        column_name: "company_manager_phone",
        col: "12",
        sm: "4",
        lg: "6",
        value: "",
        rules: [
            (v) => !!v || "필수 입력",
            (v) => (typeof v === "string" && /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/.test(v)) ||
                "번호 형식 확인(ex : 010-1234-5678)",
        ],
        disabled: true,
    },
];
export const _estimateFilesInputs = [
    {
        label: "승인서",
        column_name: "approval",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
    },
    {
        label: "도면",
        column_name: "blueprint",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
    },
    {
        label: "기타",
        column_name: "files",
        type: "file",
        col: "12",
        sm: "4",
        lg: "4",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
    },
];
// 견적서 세부 항목
export const _calcCostDetailData = [
    {
        cost_list: "재료비",
        cost_list_colspan: 4,
        belong_data: [],
    },
    {
        cost_list: "노무비",
        cost_list_colspan: 4,
        belong_data: [
            {
                cost_list: "가. 직접 노무비",
                cost_list_colspan: 4,
                belong_data: [],
            },
            {
                cost_list: "나. 간접 노무비",
                cost_unit: "식",
                cost_num: 1,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
        ],
    },
    {
        cost_list: "경비",
        cost_list_colspan: 4,
        belong_data: [
            {
                cost_list: "가. 고용보험료",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "나. 공구손료",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "다. 여비교통 통신비",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "라. 산재보험료",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "마. 세금과공과",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "바. 복리후생비",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "사. 퇴직공제 부금비",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "아. 소모품비",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
            {
                cost_list: "자. 산업안전보건관리비",
                cost_unit: "식",
                cost_num: 1,
                cost_num_editable: true,
                cost_unit_price: 0,
                belong_data: [
                    {
                        cost_list: "",
                        cost_list_colspan: 5,
                    },
                ],
            },
        ],
    },
    {
        cost_list: "일반관리비",
        cost_unit: "식",
        cost_num: 1,
        cost_unit_price: 0,
        cost_num_editable: true,
        allow_edit_decimal_point: true,
        belong_data: [
            {
                cost_list: "",
                cost_list_colspan: 5,
            },
        ],
    },
    {
        cost_list: "이윤",
        cost_unit: "식",
        cost_num: 1,
        cost_num_editable: true,
        allow_edit_decimal_point: true,
        cost_unit_price: 0,
        belong_data: [
            {
                cost_list: "",
                cost_list_colspan: 5,
            },
        ],
    },
];
